import React from "react";
import "./About.css";
import { FaRocket, FaCogs, FaLaptopCode, FaUsers } from "react-icons/fa";
import { useLocalContext } from "../../context/LocalContext";

const About = () => {
  const { webinfo } = useLocalContext();

  return (
    <section className="aboutX">
      {/* HERO */}
      <div className="aboutX-hero">
        <div className="aboutX-hero-text">
          <span className="aboutX-eyebrow">Who we are</span>
          <h1>
            Building digital systems that <span>drive real growth</span>
          </h1>
          <p>
            {webinfo.name} is a growth-focused digital agency helping founders,
            startups, and brands turn ideas into scalable digital products.
            We combine strategy, design, technology, and marketing — all under
            one roof.
          </p>
        </div>

        <div className="aboutX-hero-img">
          <img
            src="https://res.cloudinary.com/dq5rlyl05/image/upload/v1772194624/photo-1519074002996-a69e7ac46a42_fiq3ng_rkdkaj.jpg"
            alt="Team collaboration"
          />
        </div>
      </div>

      {/* WHAT WE FOCUS ON */}
      <div className="aboutX-focus">
        <h2>What We Focus On</h2>

        <div className="aboutX-grid">
          <div className="aboutX-card">
            <FaRocket className="icon" />
            <h4>Launch & Scale</h4>
            <p>
              From MVPs to full-scale platforms, we help businesses launch fast
              and scale confidently with the right technical foundation.
            </p>
          </div>

          <div className="aboutX-card">
            <FaLaptopCode className="icon" />
            <h4>Product & Web Development</h4>
            <p>
              High-performance websites, dashboards, SaaS platforms, and
              eCommerce systems — built for speed, security, and growth.
            </p>
          </div>

          <div className="aboutX-card">
            <FaCogs className="icon" />
            <h4>Automation & Systems</h4>
            <p>
              CRM workflows, lead automation, integrations, and AI-assisted
              systems that reduce manual work and improve conversions.
            </p>
          </div>

          <div className="aboutX-card">
            <FaUsers className="icon" />
            <h4>Marketing Strategy</h4>
            <p>
              SEO, paid ads, funnels, and analytics — we focus on measurable
              outcomes, not vanity metrics.
            </p>
          </div>
        </div>
      </div>

      {/* PROCESS */}
      <div className="aboutX-process">
        <h2>How We Work</h2>

        <div className="process-steps">
          <div>
            <h3>01. Understand</h3>
            <p>We start with your goals, users, and constraints.</p>
          </div>
          <div>
            <h3>02. Design & Build</h3>
            <p>Clean UX, scalable architecture, and fast execution.</p>
          </div>
          <div>
            <h3>03. Launch & Optimize</h3>
            <p>Measure performance, improve continuously, and scale.</p>
          </div>
        </div>
      </div>

      {/* METRICS */}
      <div className="aboutX-metrics">
        <div className="metric">
          <h3>100K+</h3>
          <p>Leads generated</p>
        </div>
        <div className="metric">
          <h3>5.0</h3>
          <p>Client satisfaction</p>
        </div>
        <div className="metric">
          <h3>70+</h3>
          <p>Projects delivered</p>
        </div>
        <div className="metric">
          <h3>8+ Years</h3>
          <p>Industry experience</p>
        </div>
      </div>

      {/* VISION */}
      <div className="aboutX-vision">
        <h2>Our Mission</h2>
        <p>
          To help businesses grow using smart digital systems that are simple,
          scalable, and performance-driven.
        </p>

        <h2>Our Vision</h2>
        <p>
          To become a long-term digital partner for ambitious teams — not just a
          service provider.
        </p>
      </div>
    </section>
  );
};

export default About;
